exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".main-search .form-control[data-v-3c63ac60]{flex:1 1 auto}.img-logo[data-v-3c63ac60]{height:40px}", ""]);

// exports
